















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import { User } from '@/utils/Interfaces'
import { inputRules } from '@/utils/CommonUtils'
import { handle } from '@/utils/ErrorHandling'
import { status } from '@/utils/HttpStatus'

@Component({
  components: {
    BreadCrumbs,
    SectionTitle,
  }
})
export default class TrangCaNhan extends Vue {
  breadcrumbs = [
    {
      text: 'Trang chủ',
      to: { name: 'Home' },
    },
    {
      text: 'Trang cá nhân',
      to: { name: 'TrangCaNhan' },
    },
  ]

  get user () {
    return this.$store.state.user.currentUser
  }

  inputRules = inputRules

  /**
   * Update user info
   */

  updateInfoDialog = false
  userInfo = new User
  fullnameHint = 'Thông tin in trong mục "Người lập biểu"'

  errors = {
    email: [],
    fullname: [],
  }

  get updatingUser () {
    return this.$store.state.user.updatingUser
  }

  @Watch('updateInfoDialog')
  onUpdateInfoDialogChange (isOpen: boolean) {
    if (isOpen) {
      // @ts-expect-error
      this.$refs.infoForm.resetValidation()
      this.userInfo = new User(this.user)
    }
  }

  updateInfo () {
    // @ts-expect-error
    if (!this.$refs.infoForm.validate()) return

    this.errors.email = []
    this.errors.fullname = []

    this.$store.dispatch('updateUserInfo', this.userInfo)
      .then(() => {
        this.$store.dispatch('alertMessage', 'Sửa thông tin thành công.')
        this.updateInfoDialog = false
      })
      .catch(error => {
        handle(error, {
          [status.HTTP_400_BAD_REQUEST]: () => {
            const errorData = error.response.data
            for (const [field, messages] of Object.entries(errorData)) {
              // @ts-expect-error
              this.errors[field] = messages
            }
          }
        })
      })
  }

  /**
   * Update password
   */

  updatePasswordDialog = false
  newPassword = ''
  newPasswordConfirm = ''
  showNewPassword = false
  showNewPasswordConfirm = false

  passwordsMatch () {
    return this.newPassword === this.newPasswordConfirm || 'Mật khẩu không khớp nhau'
  }

  updatePassword () {
    // @ts-expect-error
    if (!this.$refs.passwordForm.validate()) return
    this.$store.dispatch('updateUserInfo', { password: this.newPassword })
      .then(() => {
        this.$store.dispatch('alertMessage', 'Đổi mật khẩu thành công.')
        this.updatePasswordDialog = false
      })
      .catch(handle)
  }

  @Watch('updatePasswordDialog')
  onUpdatePasswordDialogChange (isOpen: boolean) {
    if (isOpen) {
      // @ts-expect-error
      this.$refs.passwordForm.resetValidation()
    }
  }
}
